import TContractList from './index.vue';

TContractList.install = app => {
  app.component(TContractList.name, TContractList);
};

export default TContractList;
